import {
  DEFAULT_BASE_COMPONENT,
  DEFAULT_TEXT_COMPONENT,
  DEFAULT_LISTING_IMAGE_COMPONENT,
  DEFAULT_LISTING_INFORMATION_COMPONENT,
  DEFAULT_LISTING_BARCODE_COMPONENT,
  TEXT_COMPONENT_KEY,
  LISTING_IMAGE_COMPONENT_KEY,
  LISTING_INFORMATION_COMPONENT_KEY,
  BASE_COMPONENT_KEY,
  DEFAULT_TEAR_SHEET_CONTENT,
  LISTING_TABLE_COMPONENT_KEY,
  DEFAULT_LISTING_TABLE_COMPONENT,
  LISTING_BARCODE_COMPONENT_KEY,
  DEFAULT_SIMPLE_LISTING_INFORMATION_COMPONENT,
  DEFAULT_LISTING_QRCODE_COMPONENT,
  LISTING_QRCODE_COMPONENT_KEY,
  DEFAULT_LISTING_MAIN_IMAGE_COMPONENT,
} from "@app/components/editor/workspace/golden-layout-definitions";
import {
  ElementRef,
  OnChanges,
  AfterViewInit,
  OnInit,
  ViewChild,
  HostListener,
  SecurityContext,
  Component,
} from "@angular/core";
import { Listing } from "@app/data/listing";
import { Plan, User } from "../../data/user";
import { File } from "../../data/file";

import { GoldenLayoutListingImageComponent } from "@app/components/editor/workspace/golden-layout-listing-image.component";
import { GoldenLayoutBaseComponent } from "@app/components/editor/workspace/golden-layout-base.component";

import { GoldenLayoutTextComponent } from "@app/components/editor/workspace/golden-layout-text.component";
import { GoldenLayoutListingInformationComponent } from "@app/components/editor/workspace/golden-layout-listing-information.component";
import * as GoldenLayout from "golden-layout";
import { ListingService } from "@app/services/listing.service";
import { UserService } from "@app/services/user.service";
import { LoaderService } from "@app/services/loader.service";
import { FileService } from "@app/services/file.service";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { ChangeDetectorRef } from "@angular/core";
import { ButtonCircleSaveComponent } from "@app/components/common/button-circle-save.component";
import { GoldenLayoutListingTableComponent } from "../editor/workspace/golden-layout-listing-table.component";
import { DomSanitizer, SafeHtml, SafeUrl } from "@angular/platform-browser";
import { GoldenLayoutListingBarcodeComponent } from "../editor/workspace/golden-layout-listing-barcode.component";
import { Catalog } from "@app/data/catalog";
import { CatalogService } from "@app/services/catalog.service";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import { HttpResponse } from "@angular/common/http";
import {
  Observable,
  OperatorFunction,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  map,
  of,
  switchMap,
} from "rxjs";
import { GoldenLayoutListingQRCodeComponent } from "@app/components/editor/workspace/golden-layout-listing-qrcode.component";
import * as _ from "lodash";
import { GoldenLayoutDirective } from "golden-layout/golden-layout.directive";

const MAX_HEIGHT = 800;
const MAX_WIDTH = 650;

@Component({
  template: "",
})
export abstract class BaseEditorComponent implements OnInit, AfterViewInit {
  protected inchToPxFactor: number;

  @ViewChild("pdfDocument")
  pdfDocumentElement: ElementRef;

  @ViewChild("saveButton") saveButton: ButtonCircleSaveComponent;
  @ViewChild("panelConfiguration") panelConfiguration: ElementRef;
  protected originalListing: Listing = new Listing();
  protected _listing: Listing = new Listing();
  protected originalListings: Listing[] = [];
  protected _listingsSelection: Listing[] = [];
  protected _listings: Listing[] = [];
  protected user: User;
  protected userModel: User;
  fonts: File[];
  protected documentURL: string;
  protected zoom: number = 1;
  pageHeight: number = 0;
  pageWidth: number = 0;
  pageContainerHeight: number = 0;
  pageContainerWidth: number = 0;
  resizeFactor: number = 0;
  paddingTop: number;
  quantity: number = 1;
  fontsLoaded: boolean = false;
  presetFonts: string[] = [];
  selectedFormat: any;
  isDownloading: boolean = false;
  protected source: string = "singleProduct";
  subscription: Subscription;
  componentsInitialized = false;
  protected plan: Plan;
  protected treeNodes = [];

  protected listingValueFormatter = (data: any) => {
    return `${data.title} ${data.sku}`;
  };

  protected listingListFormatter = (data: any) => {
    let html = `<img src="${data.main_image}" height="36"/>&nbsp;<span >${data.title} <i>${data.sku}</i></span>`;
    return this.sanitizer.sanitize(
      SecurityContext.HTML,
      this.sanitizer.bypassSecurityTrustHtml(html)
    );
  };

  @ViewChild("baseElement")
  baseElement: ElementRef;

  @ViewChild("workspaceElement")
  workspaceElement: ElementRef;

  @ViewChild("imageElement")
  imageElement: ElementRef;

  @ViewChild("mainImageElement")
  mainImageElement: ElementRef;

  @ViewChild("listingInformationElement")
  listingInformationElement: ElementRef;

  @ViewChild("simpleListingInformationElement")
  simpleListingInformationElement: ElementRef;

  @ViewChild("listingTableElement")
  listingTableElement: ElementRef;

  @ViewChild("listingBarcodeElement")
  listingBarcodeElement: ElementRef;

  @ViewChild("listingQRCodeElement")
  listingQRCodeElement: ElementRef;

  @ViewChild("textElement")
  textElement: ElementRef;

  @ViewChild("goldenLayoutContainer")
  goldenLayoutContainer: ElementRef;

  @ViewChild("pageTemplate") pageTemplate;

  @ViewChild(GoldenLayoutDirective)
  goldenLayoutDirective: GoldenLayoutDirective;

  goldenLayoutConfig: GoldenLayout.Config = {
    settings: {
      constrainDragToContainer: true,
      selectionEnabled: true,
      showMaximiseIcon: false,
      showPopoutIcon: false,
      reorderEnabled: true,
      showCloseIcon: true,
    },
    dimensions: {
      borderWidth: 1,
      headerHeight: 0,
    },
  };
  componentDefinitions = [
    {
      componentName: TEXT_COMPONENT_KEY,
      componentType: GoldenLayoutTextComponent,
    },
    {
      componentName: LISTING_IMAGE_COMPONENT_KEY,
      componentType: GoldenLayoutListingImageComponent,
    },
    {
      componentName: LISTING_INFORMATION_COMPONENT_KEY,
      componentType: GoldenLayoutListingInformationComponent,
    },
    {
      componentName: BASE_COMPONENT_KEY,
      componentType: GoldenLayoutBaseComponent,
    },
    {
      componentName: LISTING_TABLE_COMPONENT_KEY,
      componentType: GoldenLayoutListingTableComponent,
    },
    {
      componentName: LISTING_BARCODE_COMPONENT_KEY,
      componentType: GoldenLayoutListingBarcodeComponent,
    },
    {
      componentName: LISTING_QRCODE_COMPONENT_KEY,
      componentType: GoldenLayoutListingQRCodeComponent,
    },
  ];
  protected catalogs: Catalog[];
  protected catalog: Catalog;
  protected catalogSource: Catalog;
  protected isShopify: boolean;
  protected isBigcommerce: boolean;
  protected isEcwid: boolean;
  protected listingIndex = 0;
  observableSource: any;
  metafieldsTags: string[] = [];
  protected field: string;

  search: OperatorFunction<string, readonly any[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term) =>
        term.length < 1 ? of([]) : this.observableSource(term)
      ),
      map((result) => result as readonly any[])
    );

  constructor(
    private sanitizer: DomSanitizer,
    private catalogService: CatalogService,
    protected listingService: ListingService,
    protected userService: UserService,
    private loaderService: LoaderService,
    private fileService: FileService,
    private changeDetectorRef: ChangeDetectorRef,
    protected goldenLayoutService: GoldenLayoutService
  ) {
    // window.GoldenLayout.__lm.controls.DropTargetIndicator = function() {
    //     this.element = $( window.GoldenLayout.__lm.controls.DropTargetIndicator._template );
    //     $( this.goldenLayoutContainer.nativeElement ).append( this.element );
    // };
  }

  ngOnInit(): void {
    this.loaderService.isLoading = true;
    //default values
    this.listing.price = 0;
    this.listing.sku = "SKU 1";
    this.listing.title = "Product Title";
    this.listing.barcode = "123456789012";
    this.listing.iso_currency_code = "USD";
    this.listing.variations = [];
    this.goldenLayoutService.updateListing(this.listing);

    this.userService.me().then((user) => {
      this.plan = user.subscription.plan;
      this.isShopify = this.userService.isShopify(user);
      this.isBigcommerce = this.userService.isBigcommerce(user);
      this.isEcwid = this.userService.isEcwid;
      this.setUserModel(user);
      var getUrl = window.location;
      var baseUrl = getUrl.protocol + "//" + getUrl.host;
      this.initDocumentUrl(baseUrl);
      this.activateDraggableComponents();
      this.listingService.getListings().then((listings) => {
        if (listings.length > 0) {
          let listingFound;
          for (let i = 0; i < listings.length; i++) {
            let listing = listings[i];
            if (listing.images.length > 2 && listing.variations.length > 0) {
              listingFound = listing;
            }
          }
          this.listing = listingFound || listings[0];
          this.loadMetafields();
          this.generateListings([this.listing]);
          this.refreshPageDimensions();
          this.activateDraggableComponents();
        }
      });

      // this.listingService.getCategories().then(categories => {
      //     this.categories = categories;
      // });
    });

    this.observableSource = this.listingService.observableSource;
    this.fileService.get("font").then((fonts) => {
      this.fonts = fonts;
      let fontStyle = "";
      this.fonts.forEach((font) => {
        this.presetFonts.push(font.name);
        fontStyle += `
              @font-face {
                font-family: "${font.name}";
                src: url('${font.url}');
              }
              `;
      });
      $("head").append(`<style type="text/css">${fontStyle}</style>`);
      this.fontsLoaded = true;
    });
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();

    var timerId = setInterval(() => {
      this.refreshPageDimensions();
      if (this.pageHeight > 100) {
        clearTimeout(timerId);
      }
    }, 300);
    this.subscription = this.goldenLayoutService
      .getSelection()
      .subscribe((selection) => {
        if (this.panelConfiguration) {
          setTimeout(() => {
            this.panelConfiguration.nativeElement.scrollTop =
              this.panelConfiguration.nativeElement.scrollHeight;
          }, 100);
        }
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener("window:resize") onResize() {
    this.refreshPageDimensions();
  }

  loadMetafields() {
    this.metafieldsTags = [];
    this.listingService.getParent(this.listing.id).then((listing) => {
      this.listing.metafields = listing.metafields;
      this.metafieldsTags = this.metafieldsTags.concat(
        _.map(listing.metafields, (metafield) => {
          return (
            "[LISTING." +
            metafield.namespace +
            "." +
            metafield.key +
            "]"
          ).toUpperCase();
        })
      );
      // this.listing.variations = listing.variations;
      // listing.variations.forEach(variation => {
      //     variation.options.forEach(option => {
      //         if (option.metafields) {
      //             this.metafieldsTags = this.metafieldsTags.concat(_.map(option.metafields, metafield => {
      //                 return ('[VARIANT.' + metafield.namespace + '.' + metafield.key + ']').toUpperCase();
      //             }));
      //         }
      //     });
      // });
    });
  }

  generatePage(index) {
    let wrap = document.createElement("div");
    let clonedNode = this.pageTemplate.nativeElement.cloneNode(true);
    let elements = clonedNode.getElementsByTagName("*");
    this.scaleEverything(clonedNode);
    for (var i = elements.length; i--; ) {
      this.scaleEverything(elements[i]);
    }
    wrap.appendChild(clonedNode);
    // this.adService.generatePage(this.ad, wrap.innerHTML, index);
  }

  protected refreshPageDimensions() {
    if (this.userModel && this.workspaceElement) {
      var width;
      var height;
      if (this.userModel[this.field].is_landscape) {
        width =
          this.userModel[this.field].width ||
          (this.userModel.settings.page_format === "A4"
            ? tearSheetUtils.A4_PAGE_HEIGHT
            : tearSheetUtils.LETTER_PAGE_HEIGHT);
        height =
          this.userModel[this.field].height ||
          (this.userModel.settings.page_format === "A4"
            ? tearSheetUtils.A4_PAGE_WIDTH
            : tearSheetUtils.LETTER_PAGE_WIDTH);
      } else {
        width =
          this.userModel[this.field].width ||
          (this.userModel.settings.page_format === "A4"
            ? tearSheetUtils.A4_PAGE_WIDTH
            : tearSheetUtils.LETTER_PAGE_WIDTH);
        height =
          this.userModel[this.field].height ||
          (this.userModel.settings.page_format === "A4"
            ? tearSheetUtils.A4_PAGE_HEIGHT
            : tearSheetUtils.LETTER_PAGE_HEIGHT);
      }
      var pageMaxWidth;
      if (window.innerWidth > 1400) pageMaxWidth = 650;
      else if (window.innerWidth > 1200) pageMaxWidth = 550;
      else if (window.innerWidth > 992) pageMaxWidth = 550;
      else pageMaxWidth = 480;
      let widthDPI = tearSheetUtils.toPx(width);
      let heightDPI = tearSheetUtils.toPx(height);
      let rect = this.workspaceElement.nativeElement.getBoundingClientRect();
      this.zoom = Math.min(pageMaxWidth / widthDPI, MAX_HEIGHT / heightDPI);
      this.pageContainerHeight = rect.height;
      this.pageContainerWidth = rect.width;
      this.pageHeight = Math.min(
        this.zoom * heightDPI,
        0.95 * this.pageContainerHeight
      );
      this.inchToPxFactor = this.pageHeight / this.userModel[this.field].height;
      this.resizeFactor = heightDPI / this.pageHeight;
      this.pageWidth = (this.pageHeight * widthDPI) / heightDPI;

      if (this.goldenLayoutDirective) {
        this.goldenLayoutDirective.updateSize(this.pageWidth, this.pageHeight);
      }
      this.refreshDimensions();
    }
  }
  protected setUserModel(user: User) {
    this.user = user;
    this.userModel = JSON.parse(JSON.stringify(this.user));
    this.loaderService.isLoading = false;
  }

  activateDraggableComponents() {
    this.changeDetectorRef.detectChanges();
    if (this.userModel && this.listing && !this.componentsInitialized) {
      this.componentsInitialized = true;
      if (this.baseElement) {
        this.goldenLayoutDirective.createDragSource(
          this.baseElement.nativeElement,
          Object.assign({}, DEFAULT_BASE_COMPONENT)
        );
      }
      if (this.textElement) {
        this.goldenLayoutDirective.createDragSource(
          this.textElement.nativeElement,
          Object.assign({}, DEFAULT_TEXT_COMPONENT)
        );
      }
      if (this.imageElement) {
        this.goldenLayoutDirective.createDragSource(
          this.imageElement.nativeElement,
          Object.assign({}, DEFAULT_LISTING_IMAGE_COMPONENT)
        );
      }
      if (this.mainImageElement) {
        this.goldenLayoutDirective.createDragSource(
          this.mainImageElement.nativeElement,
          Object.assign({}, DEFAULT_LISTING_MAIN_IMAGE_COMPONENT)
        );
      }
      if (this.listingInformationElement) {
        this.goldenLayoutDirective.createDragSource(
          this.listingInformationElement.nativeElement,
          Object.assign({}, DEFAULT_LISTING_INFORMATION_COMPONENT)
        );
      }
      if (this.simpleListingInformationElement) {
        this.goldenLayoutDirective.createDragSource(
          this.simpleListingInformationElement.nativeElement,
          Object.assign({}, DEFAULT_SIMPLE_LISTING_INFORMATION_COMPONENT)
        );
      }
      if (this.listingTableElement) {
        this.goldenLayoutDirective.createDragSource(
          this.listingTableElement.nativeElement,
          Object.assign({}, DEFAULT_LISTING_TABLE_COMPONENT)
        );
      }
      if (this.listingBarcodeElement) {
        this.goldenLayoutDirective.createDragSource(
          this.listingBarcodeElement.nativeElement,
          Object.assign({}, DEFAULT_LISTING_BARCODE_COMPONENT)
        );
      }
      if (this.listingQRCodeElement) {
        this.goldenLayoutDirective.createDragSource(
          this.listingQRCodeElement.nativeElement,
          Object.assign({}, DEFAULT_LISTING_QRCODE_COMPONENT)
        );
      }
    }
  }
  private scaleEverything(element: any) {
    this.scale(element, "width");
    this.scale(element, "height");
    this.scale(element, "left");
    this.scale(element, "top");
  }

  private scale(element: any, dimension: string) {
    if (
      element.style[dimension] &&
      element.style[dimension].indexOf("px") > -1
    ) {
      element.style[dimension] =
        this.resizeFactor * parseInt(element.style[dimension]) + "px";
    }
  }

  protected submitDocument(download?: boolean, done?: any) {
    if (this.saveButton.status === this.saveButton.SAVING_STATUS) {
      return;
    }

    this.userModel[this.field].zoom = this.resizeFactor;
    let wrap = document.createElement("div");
    let clonedNode = this.pageTemplate.nativeElement.cloneNode(true);
    let elements = clonedNode.getElementsByTagName("*");
    // if (this.zoom === 1) {
    //     this.scaleEverything(clonedNode);
    //     for (var i = elements.length; i--;) {
    //         this.scaleEverything(elements[i]);
    //     }
    // }
    elements = clonedNode.getElementsByClassName("page-cell-preview");
    for (var i = elements.length; i--; ) {
      elements[i].innerHTML = "";
    }
    wrap.appendChild(clonedNode);
    var html = wrap.innerHTML;
    this.userModel[this.field].html = html;
    //remove preview sections

    this.saveButton.status = this.saveButton.SAVING_STATUS;
    delete this.userModel["__v"];
    this.userService
      .update(this.userModel)
      .then((user) => {
        // this.userService.me().then(user => {
        this.setUserModel(user);
        this.saveButton.status = this.saveButton.SAVED_STATUS;
        if (download) {
          // if (this.source === 'onlineStore') {
          //     window.open(this.getPDFURL())
          // } else if (this.source === 'catalog' || this.source === 'order') {
          //TODO post barcodes in bulk
          this.isDownloading = true;
          this.download().then((url) => {
            const interval = setInterval(() => {
              var request = new XMLHttpRequest();
              request.open("GET", url, false);
              request.send();
              if (request.status === 200) {
                window.open(url);
                clearInterval(interval);
                this.isDownloading = false;
              }
            }, 1000);
          });
          // }
        }
        if (done) {
          done();
        }
        // });
      })
      .catch(() => {
        this.saveButton.status = this.saveButton.FAILED_STATUS;
      });
  }

  downloadPDF(data: HttpResponse<Blob>) {
    const url = window.URL.createObjectURL(data.body);
    window.open(url);
  }

  protected contentChanged(structure) {
    this.userModel[this.field].structure = structure;
  }

  protected abstract initDocumentUrl(baseUrl: string);

  protected initComponent() {
    this.refreshPageDimensions();
    this.activateDraggableComponents();
  }

  protected updateListing(listing: Listing) {
    if (listing) {
      this.listing = listing;
      this.listings = [this.listing];
      this.loadMetafields();
    }
  }

  protected set listing(listing: Listing) {
    this._listing = listing || new Listing();

    this.originalListing = Object.assign({}, this._listing);

    this.goldenLayoutService.updateListing(this.listing);

    // if (this.userService.isEtsy  || this.userService.isEbay) {
    //     this.listingService.getParent(this.listing.id).then(listing => {
    //         this.listing = listing;
    //         this.goldenLayoutService.updateListing(this.listing);
    //     });
    // }

    this.prepareListing();
  }

  protected get listings(): Listing[] {
    return this._listings;
  }

  protected set listings(listings: Listing[]) {
    this._listings = JSON.parse(JSON.stringify(listings));
    if (this._listings.length > 0) {
      this.listing = this.listings[0];
    }
    this.goldenLayoutService.updateListings(this._listings);

    this.prepareListings();
  }

  protected get listing(): Listing {
    return this._listing;
  }

  // protected get categories(): Category[] {
  //     return this._categories;
  // }

  // protected set categories(categories: Category[]) {
  //     this._categories = categories;
  //     categories.forEach((category, index) => {
  //         this.treeNodes.push({
  //             id: category.id,
  //             name: category.title,
  //             hasChildren: true,
  //             data: category
  //         });
  //     });
  // }

  protected setFormat(format: any) {
    this.userModel[this.field].width = format.width;
    this.userModel[this.field].height = format.height;
    this.userModel[this.field].multiple_per_page = format.multiple_per_page;
    this.userModel[this.field].page_top_bottom_margin =
      format.page_top_bottom_margin;
    this.userModel[this.field].page_left_right_margin =
      format.page_left_right_margin;
    this.refreshPageDimensions();
  }

  // protected printDocument() {
  //     this.submitDocument(false, () => {
  //         console.log(this.source)
  //         if (this.source === 'onlineStore') {
  //             window.open(this.getPDFURL())
  //         } else if (this.source === 'catalog') {
  //             //TODO post barcodes in bulk
  //             this.listingService.downloadBarcodes(this.listings)
  //         }
  //     });
  // }

  protected selectOption(option) {
    // this.listing.title = `${this.originalListing.title} ${option.title === 'Default Title' ? '' : option.title}`;
    this.listing.default_variant_option = option;
    this.listing.sku = option.sku;
    this.listing.barcode = option.barcode;
    this.listing.price = option.price || this.listing.price;
  }

  protected loadCatalogs() {
    this.catalogService.getCatalogs("", 0).then((catalogs) => {
      this.catalogs = catalogs;
      if (this.catalogs.length > 0) {
        this.catalogs.sort(function (a, b) {
          return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
        });
        this.catalogSource = this.catalogs[0];
        this.catalogSourceChanged(this.catalogSource);
      }
    });
  }

  protected catalogSourceChanged(catalog: Catalog) {
    this.catalogService.getCatalog(catalog._id).then((fullCatalog) => {
      this.catalog = fullCatalog;
      if (!this.catalog.listings) {
        tearSheetUtils.initListingsCategories(this.catalog);
      }
      if (this.source === "catalog") {
        this.generateListings(this.catalog.listings);
      }
    });
  }

  protected generateListings(originalListings) {
    this.listingIndex = 0;
    this.originalListings = Object.assign([], originalListings);
    var listings = [];
    if (this.source === "catalog" && this.includeVariants()) {
      this.originalListings.forEach((listing) => {
        var modifiedListing = JSON.parse(JSON.stringify(listing));
        if (listing.variations) {
          var count = 0;
          listing.variations.forEach((variation) => {
            variation.options.forEach((option) => {
              modifiedListing.default_variant_option = option;
              modifiedListing.barcode = option.barcode;
              listings.push(Object.assign({}, modifiedListing));
              count++;
            });
          });
          if (count === 0) {
            listings.push(modifiedListing);
          }
        }
      });
    } else if (this.source === "order") {
      this.originalListings.forEach(function (listing) {
        listing.quantity = listing.quantity || 1;
        let title = listing.title;
        if (listing.default_variant_option) {
          Object.assign(listing, listing.default_variant_option);
          listing.title = `${title} ${listing.title}`;
        }

        for (var i = 0; i < listing.quantity; i++) {
          listings.push(listing);
        }
      });
    } else if (this.source === "singleProduct") {
      for (let i = 0; i < this.quantity; i++) {
        this.originalListings.forEach(function (listing) {
          listings.push(listing);
        });
      }
    } else {
      this.originalListings.forEach(function (listing) {
        listings.push(listing);
      });
    }
    this.listings = listings;
  }

  protected sourceChanged() {
    this.listings = [];
    this.originalListings = [];
    if (this.source === "catalog") {
      this.loadCatalogs();
    } else if (this.source === "onlineStore") {
      this.generateListings(this._listingsSelection);
    } else if (this.source === "singleProduct") {
      this.generateListings([this.listing]);
    }
  }

  protected previousProduct() {
    this.listingIndex--;
    if (this.listingIndex < 0) {
      this.listingIndex = this.listings.length - 1;
    }
    this.listing = this.listings[this.listingIndex];
  }

  protected nextProduct() {
    this.listingIndex++;
    if (this.listingIndex > this.listings.length - 1) {
      this.listingIndex = 0;
    }
    this.listing = this.listings[this.listingIndex];
  }

  protected listingsChanged(listings) {}

  protected get listingsSelection(): Listing[] {
    return this._listingsSelection;
  }

  protected listingsSelectionChanged(listings: Listing[]) {
    this._listingsSelection = listings;
    this.generateListings(listings);
  }

  protected prepareListing() {}
  protected prepareListings() {}

  protected refreshDimensions() {}

  protected abstract download(): Promise<string>;

  protected includeVariants(): boolean {
    return false;
  }
}
